import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _templateObject;
var _excluded = ["nodeType", "editMode", "defaultValue", "multiple", "creatable", "showDisplayLabel", "updateAfterGetNodes", "extraParams"],
  _excluded2 = ["initialValue", "name", "onChange", "onBlur", "nodeToString", "extraParams", "multiple", "selectableIds", "excludedIds", "nodeType", "onCreate", "creatable", "renderInputField", "renderSuggestions", "id", "onInputValueChange", "showDisplayLabel", "hasDefaultValue"],
  _excluded3 = ["getInputProps", "getLabelProps", "itemToString", "isOpen", "clearSelection", "toggleMenu", "selectedItems", "selectedItem", "removeItem"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
// @ts-nocheck
//
// Hey, are you working in this file?
// Remove this block of code and help make our codebase a little bit stronger
//
// Do a little bit now to pay down the tech debt
import { Icon, IconButton } from "components/mui";
import SelectChip from "components/mui/Fields/Fields/SelectField/SelectChip";
import { gql } from "@apollo/client";
import { useAsyncSelectGetNodesQuery } from "raise-types";
import * as React from "react";
import DefaultAutocompleteInputField from "../../Fields/AutoComplete/DefaultAutocompleteInputField";
import CompSelectFragment__CompNode from "../CompSelect/CompSelectFragment__CompNode";
import DealroomlistingSelectFragment__DealroomlistingNode from "../DealroomlistingSelect/DealroomlistingSelectFragment__DealroomlistingNode";
import MasterlistingSelectFragment__MasterlistingNode from "../MasterlistingSelect/MasterlistingSelectFragment__MasterlistingNode";
import DefaultAsyncSuggestionsMenu from "./DefaultAsyncSuggestionsMenu";
import MultiDownshift from "./MultiDownshift";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* NOTE: Downshift has performance issues where it causes unncessary re-renders. E.g. when using this component 
w/ a menu, there will be a callback everytime when the menu is opened and a user is moving a mouse over the elements.
This is evident in use cases such as `CompSelect`. There is a fix for this in a later version of Downshift and requires 
migrating to using hooks provided in the API.
https://github.com/downshift-js/downshift/issues/730

*/

var AsyncSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _data$selectableNodes;
  var nodeType = _ref.nodeType,
    _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    defaultValue = _ref.defaultValue,
    multiple = _ref.multiple,
    creatable = _ref.creatable,
    _ref$showDisplayLabel = _ref.showDisplayLabel,
    showDisplayLabel = _ref$showDisplayLabel === void 0 ? false : _ref$showDisplayLabel,
    _ref$updateAfterGetNo = _ref.updateAfterGetNodes,
    updateAfterGetNodes = _ref$updateAfterGetNo === void 0 ? false : _ref$updateAfterGetNo,
    extraParams = _ref.extraParams,
    props = _objectWithoutProperties(_ref, _excluded);
  // We need this to grab the currently selected nodes. If multiple, the values will already be stored in an array
  var queryVariableNodes = defaultValue ? multiple ? defaultValue : [defaultValue] : [];

  // Convert node to display string to display in suggestions dropdown
  var nodeToString = function nodeToString(node) {
    var _node$displayLabel;
    return (_node$displayLabel = node === null || node === void 0 ? void 0 : node.displayLabel) !== null && _node$displayLabel !== void 0 ? _node$displayLabel : "";
  }; // default to empty string to avoid react controlled vs uncontrolled warnings when menu closes

  // Get data for selected nodes (e.g. display label, listing state , etc)
  // Use extraParams to pass additional criteria to backend (e.g. get selected markets based on regionId)
  // Once query is completed, if updateAfterGetNodes, call onChange to update the parent UI based on data received from this query
  var _useAsyncSelectGetNod = useAsyncSelectGetNodesQuery({
      variables: {
        nodeType: nodeType,
        // If showDisplayLabel, nodes will be in an object w/ shape { id: string, displayLabel: string }
        ids: showDisplayLabel ? _mapInstanceProperty(queryVariableNodes).call(queryVariableNodes, function (node) {
          return node.id;
        }) : queryVariableNodes,
        extraParams: extraParams ? _JSON$stringify(extraParams) : null
      },
      skip: multiple ? defaultValue && defaultValue.length === 0 : !defaultValue,
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      notifyOnNetworkStatusChange: true,
      onCompleted: function onCompleted(data) {
        var nodes = data === null || data === void 0 ? void 0 : data.selectableNodes;
        var value = null;
        if (!updateAfterGetNodes && !multiple && nodes !== null) {
          return;
        }

        // If showDisplayLabel, we want to return the value w/ the id and displayLabel so the caller of the component
        // has access to the displayLabel information
        if (showDisplayLabel) {
          value = _mapInstanceProperty(nodes).call(nodes, function (item) {
            return {
              id: item === null || item === void 0 ? void 0 : item.id,
              displayLabel: item === null || item === void 0 ? void 0 : item.displayLabel
            };
          });
        } else {
          value = _mapInstanceProperty(nodes).call(nodes, function (item) {
            return item === null || item === void 0 ? void 0 : item.id;
          });
        }
        return props.onChange({
          target: {
            name: props.name,
            value: value
          }
        });
      }
    }),
    data = _useAsyncSelectGetNod.data,
    loading = _useAsyncSelectGetNod.loading,
    error = _useAsyncSelectGetNod.error,
    networkStatus = _useAsyncSelectGetNod.networkStatus;

  // need to ensure we've loaded at least once before showing the inputs
  // or else you get a visual bug when selecting the first option
  // networkStatus == 4 is refetching
  if (loading && networkStatus !== 4) {
    return "Loading...";
  }
  if (error) {
    return "Error fetching data";
  }
  var nodes = (_data$selectableNodes = data === null || data === void 0 ? void 0 : data.selectableNodes) !== null && _data$selectableNodes !== void 0 ? _data$selectableNodes : [];

  // the backend sends nodes back as an array so if not multiple
  // we grab the first element
  var nodeValue = nodes.length > 0 ? nodes[0] : null;
  if (multiple) {
    nodeValue = nodes.length > 0 ? nodes : null;
  }
  if (!editMode) {
    var _nodeValue$displayLab, _nodeValue;
    if (multiple) {
      return _mapInstanceProperty(nodeValue).call(nodeValue, function (n) {
        var _n$displayLabel;
        return "".concat((_n$displayLabel = n === null || n === void 0 ? void 0 : n.displayLabel) !== null && _n$displayLabel !== void 0 ? _n$displayLabel : "--");
      });
    }
    return (_nodeValue$displayLab = (_nodeValue = nodeValue) === null || _nodeValue === void 0 ? void 0 : _nodeValue.displayLabel) !== null && _nodeValue$displayLab !== void 0 ? _nodeValue$displayLab : "--";
  }
  return /*#__PURE__*/_jsx(AsyncAutoComplete, _objectSpread({
    ref: ref,
    nodeType: nodeType,
    initialValue: nodeValue,
    nodeToString: nodeToString,
    multiple: multiple,
    creatable: creatable,
    showDisplayLabel: showDisplayLabel,
    extraParams: extraParams,
    hasDefaultValue: !!defaultValue
  }, props));
});
export default AsyncSelect;
var AsyncAutoComplete = /*#__PURE__*/React.forwardRef(function (_ref2, forwardRef) {
  var initialValue = _ref2.initialValue,
    name = _ref2.name,
    _onChange = _ref2.onChange,
    _ref2$onBlur = _ref2.onBlur,
    onBlur = _ref2$onBlur === void 0 ? function () {} : _ref2$onBlur,
    nodeToString = _ref2.nodeToString,
    extraParams = _ref2.extraParams,
    _ref2$multiple = _ref2.multiple,
    multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
    selectableIds = _ref2.selectableIds,
    excludedIds = _ref2.excludedIds,
    nodeType = _ref2.nodeType,
    onCreate = _ref2.onCreate,
    creatable = _ref2.creatable,
    renderInputField = _ref2.renderInputField,
    renderSuggestions = _ref2.renderSuggestions,
    id = _ref2.id,
    onInputValueChange = _ref2.onInputValueChange,
    showDisplayLabel = _ref2.showDisplayLabel,
    hasDefaultValue = _ref2.hasDefaultValue,
    muiFieldProps = _objectWithoutProperties(_ref2, _excluded2);
  var inputFieldRef = React.useRef();
  var handleBlur = function handleBlur() {
    return onBlur({
      target: {
        name: name
      }
    });
  };
  if (creatable && !onCreate) {
    throw new Error("onCreate function must be provided with a creatable select");
  }
  return /*#__PURE__*/_jsx("div", {
    ref: inputFieldRef,
    style: {
      width: "100%",
      paddingLeft: "0px",
      paddingRight: "0px"
    },
    children: /*#__PURE__*/_jsx(MultiDownshift, {
      ref: forwardRef,
      multiple: multiple,
      initialSelectedItem: initialValue,
      itemToString: nodeToString,
      name: name,
      onChange: function onChange(nextValue) {
        var value = null;
        if (creatable && nextValue && multiple) {
          var newValues = _filterInstanceProperty(nextValue).call(nextValue, function (v) {
            return v.isNew;
          });
          if (newValues.length !== 0) {
            var _context;
            onCreate(newValues);
            value = _filterInstanceProperty(_context = _mapInstanceProperty(nextValue).call(nextValue, function (item) {
              return item === null || item === void 0 ? void 0 : item.id;
            })).call(_context, function (item) {
              return item;
            });
            return _onChange({
              target: {
                name: name,
                value: value,
                chosenItem: newValues
              }
            });
          }
        }
        if (creatable && nextValue && nextValue.isNew) {
          onCreate(nextValue);
          return _onChange({
            target: {
              name: name,
              value: null
            }
          });
        }
        if (creatable) {
          onCreate(null);
        }

        // If multiple is true, then nextValue will be an array of objects, otherwise nextValue is a single object
        // If showDisplayLabel, we want to return the value w/ the id and displayLabel so the caller of the component
        // has access to the displayLabel information
        if (multiple) {
          if (showDisplayLabel) {
            value = _mapInstanceProperty(nextValue).call(nextValue, function (item) {
              return {
                id: item === null || item === void 0 ? void 0 : item.id,
                displayLabel: item === null || item === void 0 ? void 0 : item.displayLabel
              };
            });
          } else {
            value = _mapInstanceProperty(nextValue).call(nextValue, function (item) {
              return item === null || item === void 0 ? void 0 : item.id;
            });
          }
        } else {
          value = showDisplayLabel ? {
            id: nextValue === null || nextValue === void 0 ? void 0 : nextValue.id,
            displayLabel: nextValue === null || nextValue === void 0 ? void 0 : nextValue.displayLabel
          } : nextValue === null || nextValue === void 0 ? void 0 : nextValue.id;
        }
        return _onChange({
          target: {
            name: name,
            value: value,
            chosenItem: nextValue
          }
        });
      },
      onOuterClick: handleBlur,
      onSelect: handleBlur,
      onInputValueChange: onInputValueChange,
      children: function children(downshiftProps) {
        var getInputProps = downshiftProps.getInputProps,
          getLabelProps = downshiftProps.getLabelProps,
          itemToString = downshiftProps.itemToString,
          isOpen = downshiftProps.isOpen,
          clearSelection = downshiftProps.clearSelection,
          toggleMenu = downshiftProps.toggleMenu,
          selectedItems = downshiftProps.selectedItems,
          selectedItem = downshiftProps.selectedItem,
          removeItem = downshiftProps.removeItem,
          other = _objectWithoutProperties(downshiftProps, _excluded3);
        if (hasDefaultValue && !multiple && !initialValue && selectedItem) {
          clearSelection();
        }
        var mapItemToChip = function mapItemToChip(item, index) {
          var _context2;
          return /*#__PURE__*/_jsx(SelectChip, {
            tabIndex: -1,
            label: itemToString(item),
            onDelete: function onDelete() {
              return removeItem(item);
            },
            color: "primary",
            disableIcon: muiFieldProps.disabled
          }, _concatInstanceProperty(_context2 = "".concat(index, "#")).call(_context2, itemToString(item)));
        };
        var inputFieldProps = _objectSpread({
          InputLabelProps: getLabelProps({
            shrink: multiple && selectedItems.length > 0 ? true : undefined,
            // undefined b/c false causes shrink on MasterlistingSelect
            htmlFor: id
          }),
          InputProps: getInputProps({
            onChange: function onChange(e) {
              if (e.target.value === "") {
                clearSelection();
              }
            },
            onClick: function onClick() {
              if (!isOpen && !muiFieldProps.disabled) {
                toggleMenu();
              }
            },
            onFocus: function onFocus(e) {
              e.target.select();
            },
            name: name,
            inputRef: inputFieldRef,
            startAdornment: multiple ? _mapInstanceProperty(selectedItems).call(selectedItems, mapItemToChip) : null,
            id: id,
            style: {
              padding: "2px 0px 2px 4px"
            }
          }),
          suffix: multiple || selectedItem == null || muiFieldProps.disabled ? null : /*#__PURE__*/_jsx(IconButton, {
            onClick: function onClick() {
              clearSelection();
              toggleMenu();
            },
            children: /*#__PURE__*/_jsx(Icon, {
              className: "fal fa-times",
              fontSize: "small"
            })
          })
        }, muiFieldProps);
        var suggestionsProps = _objectSpread({
          isOpen: isOpen,
          QueryVariables: {
            nodeType: nodeType,
            selectableIds: selectableIds,
            excludedIds: excludedIds,
            extraParams: extraParams
          },
          creatable: creatable,
          anchorEl: inputFieldRef === null || inputFieldRef === void 0 ? void 0 : inputFieldRef.current
        }, downshiftProps);
        return /*#__PURE__*/_jsxs("div", {
          children: [renderInputField ? renderInputField(_objectSpread(_objectSpread({}, inputFieldProps), multiple ? {
            selectedItems: selectedItems
          } : {
            selectedItem: selectedItem
          })) : /*#__PURE__*/_jsx(DefaultAutocompleteInputField, _objectSpread({}, inputFieldProps)), renderSuggestions ? renderSuggestions(_objectSpread(_objectSpread({}, suggestionsProps), {}, {
            selectedItems: selectedItems || [selectedItem] || []
          })) : /*#__PURE__*/_jsx(DefaultAsyncSuggestionsMenu, _objectSpread(_objectSpread({}, suggestionsProps), {}, {
            multiple: multiple
          }))]
        });
      }
    })
  });
});
gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query AsyncSelectGetNodes(\n        $ids: [UUID]!\n        $nodeType: SelectableNodeEnum!\n        $extraParams: JSONString\n    ) {\n        selectableNodes(ids: $ids, nodeType: $nodeType, extraParams: $extraParams) {\n            id\n            displayLabel\n\n            ... on MasterlistingNode {\n                id\n                listingState\n                ...MasterlistingSelectFragment\n            }\n            ... on DealroomlistingNode {\n                id\n                dlListingState: listingState\n                ...DealroomlistingSelectFragment\n            }\n            ... on CompNode {\n                id\n                compListingState: listingState\n                ...CompSelectFragment\n            }\n        }\n    }\n\n    ", "\n    ", "\n    ", "\n"])), MasterlistingSelectFragment__MasterlistingNode, DealroomlistingSelectFragment__DealroomlistingNode, CompSelectFragment__CompNode);